import React, { useState, useEffect, Suspense } from "react";
import "./App.css";
import Layout from "./layout/Layout";

import { BrowserRouter } from "react-router-dom";
import Router from "./routes/Router";
import ThemeProvider from "./provider/ThemeProvider";
import { SnackbarProvider } from "./provider/SnackbarProvider";
import UserProvider from "./users/providers/UserProvider";
import { CartProvider } from "./provider/CartProvider";
import CartDrawer from "./components/CartDrawer";
import CookieConsent from "./components/CookieConsent";
import MarketingPopup from "./components/MarketingPopup";
import { HelmetProvider } from "react-helmet-async";
import Spinner from "./components/Spinner";
import ErrorBoundary from "./components/ErrorBoundary";

function App() {
  const [showMarketingPopup, setShowMarketingPopup] = useState(false);

  useEffect(() => {
    // Show marketing popup after 3 seconds
    const timer = setTimeout(() => {
      setShowMarketingPopup(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <CartProvider>
          <div className="App">
            <BrowserRouter>
              <ThemeProvider>
                <SnackbarProvider>
                  <UserProvider>
                    <CartDrawer />
                    <CookieConsent />
                    <MarketingPopup
                      open={showMarketingPopup}
                      onClose={() => setShowMarketingPopup(false)}
                    />
                    <Layout>
                      <Suspense fallback={<Spinner />}>
                        <Router />
                      </Suspense>
                    </Layout>
                  </UserProvider>
                </SnackbarProvider>
              </ThemeProvider>
            </BrowserRouter>
          </div>
        </CartProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
